export const RESERVED_COUNTRY_LIST = {
  '00': 'Global',
  '10': 'Other',
  EU: 'EU',
  WO: 'WIPO',
  OAPI: 'OAPI',
  BX: 'Benelux',
};
export const CUSTOM_COUNTRY_NAME_LIST = {
  GB: 'United Kingdom',
};
export const breakpoints = {
  // 1300px 미만
  xxxSm: '(max-width: 1299px)',
  // 1463px 미만
  xxSm: '(max-width: 1462px)',
  // 1463px ~ 1636px
  xSm: '(min-width: 1463px) and (max-width: 1636px)',
  // 1636px ~ SIZE_BREAK_POINT
  sm: '(min-width: 1637px) and (max-width: 1652px)',
  // SIZE_BREAK_POINT ~ 1848px
  md: '(min-width: 1653px) and (max-width: 1848px)',
  // 1848px ~ 2044px
  lg: '(min-width: 1849px) and (max-width: 2044px)',
  // 2044px 초과
  xLg: '(min-width: 2045px)',
  // 2100px 초과
  xxLg: '(min-width: 2101px)',
};
